// extracted by mini-css-extract-plugin
module.exports = {"container":"_1ntJUkiDWvvZi7xBlm5oNf","groupsList":"_3ACI-BhAKVCUiq_1A0IXuQ"};